<template>
    <Fragment>
        <div class="overlay-loader" v-if="isLoading">
            <div class="spinner"></div>
        </div>

        <slot v-else></slot>
    </Fragment>
</template>
<script>
import { Fragment } from 'vue-fragment';

export default {
    name: 'OverlayLoader',

    components: {
        Fragment,
    },

    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style lang="scss" scoped>
.spinner {
  width: 40px;
  height: 40px;
  margin: 40px auto;
  background-color: $yellow;

  border-radius: 100%;
  -webkit-animation: sk-scaleout 1.0s infinite ease-in-out;
  animation: sk-scaleout 1.0s infinite ease-in-out;
}

@-webkit-keyframes sk-scaleout {
  0% { -webkit-transform: scale(0) }
  100% {
    -webkit-transform: scale(1.0);
    opacity: 0;
  }
}

@keyframes sk-scaleout {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 100% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
    opacity: 0;
  }
}
</style>
